// import React, { useState } from 'react';
// import './css/Account.css';

// const Account = () => {
//   // State to track edit mode and user details
//   const [isEditing, setIsEditing] = useState(false);
//   const [userDetails, setUserDetails] = useState({
//     api: '',
//     ytPassword: '',
//     email: 'userjack@example.com',
//     password: '********',
//   });

//   // Toggle edit mode
//   const handleEditClick = () => {
//     setIsEditing(!isEditing);
//   };

//   // Handle input changes when in edit mode
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setUserDetails((prevDetails) => ({
//       ...prevDetails,
//       [name]: value,
//     }));
//   };

//   return (
//     <div className="account-container">
//       <header className="account-header">
//         <h1>Account</h1>
//         <button className="menu-button" onClick={handleEditClick}>
//           {isEditing ? 'Save' : 'Edit'}
//         </button>
//       </header>

//       <div className="section-container">
//         <div className="box youtube-box">
//           <label>API : (optional)</label>
//           <br />
//           {isEditing ? (
//             <input
//               type="text"
//               name="api"
//               value={userDetails.api}
//               onChange={handleChange}
//               className="input-box"
//             />
//           ) : (
//             <p>{userDetails.api || 'No API provided'}</p>
//           )}
//           <br />
//           <label>Youtube Credentials : (optional)</label>
//           <br />
//           <label>YT Password :</label>
//           {isEditing ? (
//             <input
//               type="password"
//               name="ytPassword"
//               value={userDetails.ytPassword}
//               onChange={handleChange}
//               className="input-box"
//             />
//           ) : (
//             <p>{userDetails.ytPassword ? '********' : 'No YT Password'}</p>
//           )}
//         </div>

//         <div className="box account-box">
//           <label>Email :</label>
//           {isEditing ? (
//             <input
//               type="email"
//               name="email"
//               value={userDetails.email}
//               onChange={handleChange}
//               className="input-box"
//             />
//           ) : (
//             <p>{userDetails.email}</p>
//           )}
//           <br />
//           <label>Password :</label>
//           {isEditing ? (
//             <input
//               type="password"
//               name="password"
//               value={userDetails.password}
//               onChange={handleChange}
//               className="input-box"
//             />
//           ) : (
//             <p>{userDetails.password ? '********' : 'No Password'}</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Account;


import React, { useEffect, useState } from 'react';
import './css/Account.css';
import { useNavigate } from 'react-router-dom';

const Account = () => {
  const navigate = useNavigate();
  // State to hold user details
  const [userDetails, setUserDetails] = useState({
    name: '',
    email: '',
  });

  // Load data from localStorage on component mount
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    if (userInfo) {
      setUserDetails({
        name: userInfo.name || 'No Name Provided',
        email: userInfo.email || 'No Email Provided',
      });
    }
  }, []);

  // Handle logout
  const handleLogout = () => {
    localStorage.clear(); // Clear all data from localStorage
    window.location.href = '/'; // Redirect to login page
  };

  return (
    <div className="account-container">
      <div className='head'>
      <button className = 'back-button' onClick={() => navigate('/')} >
        &#x227A;
      </button>
      <h5 style={{ color: '#fff' }} onClick={() => navigate('/')} >Back</h5>
      </div>
      <div className='login-container background-transparent'>
        <h1 className="logo-login middle-align" onClick={() =>navigate('/')}>
        <img src="/CommentInsight Favicon.png" alt="Logo" className="logo-image" />
          CommentInsight</h1>
      </div>
      {/* <h1 className='logo'>CommentInsight</h1> */}
      
      <header className="account-header">
        <h1 className='middle-align'>
        <svg xmlns="http://www.w3.org/2000/svg" height="44px" viewBox="0 -960 960 960" width="54px" fill="#FFFFFF"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Z"/></svg>
          Account</h1>
        <button className="improve-btn" onClick={handleLogout}>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"/></svg>
          Log out
        </button>
      </header>

      <div className="section-container">
        <div className="box account-box">
          <label className='left-align'>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="34px" fill="#FFFFFF"><path d="M560-440h200v-80H560v80Zm0-120h200v-80H560v80ZM200-320h320v-22q0-45-44-71.5T360-440q-72 0-116 26.5T200-342v22Zm160-160q33 0 56.5-23.5T440-560q0-33-23.5-56.5T360-640q-33 0-56.5 23.5T280-560q0 33 23.5 56.5T360-480ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z"/></svg>
            Name:</label>
          <p className='account-detail'>{userDetails.name}</p>
          <br />
          <label className='left-align'>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="34px" fill="#FFFFFF"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480v58q0 59-40.5 100.5T740-280q-35 0-66-15t-52-43q-29 29-65.5 43.5T480-280q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480v58q0 26 17 44t43 18q26 0 43-18t17-44v-58q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93h200v80H480Zm0-280q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z"/></svg>
            Email:</label>
          <p className='account-detail'>{userDetails.email}</p>
         
        </div>
      </div>
      <div className="section-container">
        <p className='middle-align blue-color-underline' onClick={()=>{navigate('/forget-password')}}>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"/></svg>
          Reset Your Password</p>
        
        </div>
    </div>
  );
};

export default Account;
